import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from '@/store'
import PrimeVue from 'primevue/config'
import Material from '@primevue/themes/material'
import ConfirmationService from 'primevue/confirmationservice'
import 'primeicons/primeicons.css'
import 'vue-toastification/dist/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'jquery/dist/jquery.min'
import './assets/main.css'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(PrimeVue, {
  theme: {
    preset: Material,
    ripple: false,
    options: {
      darkModeSelector: false,
    },
  },
})
app.use(ConfirmationService)
app.mount('#app')
